var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgFullScreenExit(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 40 40",
    fill: "currentColor",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 40,
    fill: "#0F1118",
    opacity: 0.8,
    rx: 5
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    d: "M28,22 L28,24 L24,24.001 L24,28 L22,28 L22,24 C22,22.9456382 22.8158778,22.0818349 23.8507377,22.0054857 L24,22 L28,22 Z M16,22 L16.1492623,22.0054857 C17.1841222,22.0818349 18,22.9456382 18,24 L18,24 L18,28 L16,28 L16,24 L12,24 L12,22 L16,22 Z M24,12 L24.001,16 L28,16 L28,18 L24,18 C22.9456382,18 22.0818349,17.1841222 22.0054857,16.1492623 L22,16 L22,16 L22,12 L24,12 Z M18,12 L18,16 L18,16 L17.9945143,16.1492623 C17.9181651,17.1841222 17.0543618,18 16,18 L16,18 L12,18 L12,16 L15.999,16 L16,12 L18,12 Z"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFullScreenExit);
export default __webpack_public_path__ + "static/media/full-screen-exit.c31e8298ab8d8525cb228087b87292b2.svg";
export { ForwardRef as ReactComponent };